import React, { Fragment, useState, useCallback, useRef } from 'react';
import T from 'prop-types';
import { isBoolean } from 'lodash-es';

import DataLayoutModal from '../Modals/DataLayoutModal';
import RadioButtonGroup from '../../../RadioButtonGroup';

export const layouts = [
  ['horizontal', 'Columns'],
  ['vertical', 'Rows'],
];
const makeOptions = (openModal) =>
  layouts.map(([value, text]) => ({
    id: value,
    value,
    text,
    subElement: (
      <span className="data-layout-link" onClick={() => openModal(true, value)}>
        see example
      </span>
    ),
  }));

const DataLayout = ({ active, onChange }) => {
  const activeLayoutRef = useRef('vertical');

  const [isModalOpen, setModalOpen] = useState(false);

  const toggleModalOpen = useCallback((nextState, layout) => {
    activeLayoutRef.current = layout;
    setModalOpen((prevState) => (isBoolean(nextState) ? nextState : !prevState));
  }, []);

  const { current: options } = useRef(makeOptions(toggleModalOpen));

  return (
    <Fragment>
      <section className="export-settings-section align-items-center">
        <div className="export-settings-section__about">
          <h4 className="h5 export-settings-section__title">Data Layout</h4>
          <p className="paragraph-md export-settings-section__description">
            Determines how your data is organized in the export file.
          </p>
        </div>
        <div className="export-settings-section__content">
          <RadioButtonGroup
            active={active}
            options={options}
            name="data-layout"
            className="export-settings-section__options data-layout-options"
            enabled
            onChange={onChange}
          />
        </div>
      </section>

      {isModalOpen && (
        <DataLayoutModal
          open={isModalOpen}
          layout={activeLayoutRef.current}
          onClose={toggleModalOpen}
        />
      )}
    </Fragment>
  );
};

DataLayout.propTypes = {
  active: T.string.isRequired,
  onChange: T.func.isRequired,
};

export default DataLayout;
